const year = [
  { label: "Less than 1 year", value: "1" },
  { label: "1 - 2 years", value: "2" },
  { label: "3 - 5 years", value: "3" },
  { label: "6 - 10 years", value: "4" },
  { label: "11 - 15 years", value: "5" },
  { label: "16 - 20 years", value: "6" },
  { label: "More than 20 years", value: "7" },
];

export default year;